import React, { useState } from 'react';

const APEDARegistration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formStatus, setFormStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: 'I need help with APEDA Registration.',
    website_hp: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  
  try {
    const response = await fetch("https://akiradvisory.in/send_mail.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      setFormStatus('success');
      // Reset form while keeping the default message
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: 'I need help with APEDA registration.',
        website_hp: ''
      });
    } else {
      setFormStatus('error');
    }
  } catch (error) {
    setFormStatus('error');
  } finally {
    setIsSubmitting(false);
    setTimeout(() => setFormStatus(''), 5000);
  }
};

  return (
    <main>
      {/* Hero Section */}
      <section className="relative bg-blue-700 pt-16 pb-12">
        <div className="absolute inset-0 opacity-10 bg-cover bg-center"></div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="lg:w-2/3">
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              APEDA Registration
            </h1>

            <p className="mt-4 text-xl text-blue-100">
              APEDA (Agricultural & Processed Food Products Export Development Authority) Registration is mandatory for businesses exporting scheduled agricultural and processed food products from India. The registration grants access to a Registration-Cum-Membership Certificate (RCMC), issued under the APEDA Act, which is necessary to claim export incentives, participate in subsidy schemes, and enhance global market access.
            </p>
            <div className="mt-8">
              <a href="#contact-section" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                  <span className="mr-2">📈</span> Expand Your Global Agri-Export Reach
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Navigation */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-16 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <ul className="flex space-x-6 overflow-x-auto text-sm font-medium">
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#details">Overview & Benefits</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#procedure">Registration Process</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#documents">Documents Required</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#you-get">What You Get</a></li>
                <li><a className="py-3 inline-block border-b-2 border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-600 transition duration-150" href="#service-faqs">FAQs</a></li>
            </ul>
        </div>
      </section>

      {/* Overview Section */}
      <section id="details" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b pb-2">
                Overview of APEDA Registration
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                APEDA (Agricultural & Processed Food Products Export Development Authority) Registration is mandatory for businesses exporting scheduled agricultural and processed food products from India.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                The registration grants access to a Registration-Cum-Membership Certificate (RCMC), issued under the APEDA Act, which is necessary to claim export incentives, participate in subsidy schemes, and enhance global market access.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                APEDA registration ensures compliance with quality standards and provides exporters with the necessary credentials to expand their international trade operations in agricultural and processed food sectors.
              </p>

              <div className="mt-8">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">
                  Key Features & Benefits
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Export Eligibility:</strong> Official permission to export listed products under APEDA Act.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Government Incentives:</strong> Enables access to export subsidies, grants, and promotional schemes.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Market Expansion:</strong> Facilitates participation in international trade fairs, exhibitions, and global export opportunities.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Training and Information:</strong> Provides exporters with guidelines, product updates, and specialized training sessions.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Financial Assistance:</strong> Access to funding, packaging, infrastructure upgrades, and research support.
                    </div>
                  </li>
                  <li className="flex items-start">
                    <span className="mr-3 flex-shrink-0 text-green-500 mt-1">✅</span>
                    <div>
                        <strong className="font-semibold">Single Registration:</strong> One-time registration valid for all scheduled products, governed by APEDA regulations.
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-1" id="contact-section">
              <div className="bg-gray-50 p-6 rounded-xl shadow-xl border-t-4 border-blue-600 sticky top-28">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                  Quick Enquiry
                </h3>
                
                {formStatus === 'success' && (
                  <div className="p-4 bg-green-100 text-green-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">✅</span>
                    Thank you! Your enquiry has been submitted. We'll contact you shortly.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="p-4 bg-red-100 text-red-800 rounded-lg flex items-center mb-4">
                    <span className="mr-2">❌</span>
                    There was an error submitting your form. Please try again.
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleFormSubmit}>
                  <input 
                    type="text" 
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Full Name" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email Address" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <input 
                    type="tel" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone Number" 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required 
                  />
                  <textarea 
                    rows="3" 
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="I need help with APEDA Registration." 
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                    required
                  ></textarea>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition disabled:bg-blue-400 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3 inline-block"></div>
                        Submitting...
                      </>
                    ) : (
                      'Request an Initial Consultation'
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Procedure Section */}
      <section id="procedure" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Our Comprehensive Process
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              8 Steps for APEDA Registration
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4 grid-flow-row-dense">
            {[
              { number: "01", icon: "💬", title: "Consultation & Eligibility Check", desc: "Assess your product list and export eligibility under APEDA." },
              { number: "02", icon: "📁", title: "Document Preparation", desc: "Gather all mandatory documents (IEC, bank certificate, PAN, etc.)." },
              { number: "03", icon: "👤", title: "Account Creation", desc: "Register on the DGFT/APEDA portal with business details and contact info." },
              { number: "04", icon: "📤", title: "Online Application Submission", desc: "Fill out and submit the APEDA registration form online." },
              { number: "05", icon: "📎", title: "Document Upload", desc: "Upload electronic copies of documents in specified formats." },
              { number: "06", icon: "💳", title: "Payment of Fees", desc: "Pay the registration fee (₹5000 + GST) via secure gateway." },
              { number: "07", icon: "🔍", title: "Verification & Approval", desc: "APEDA reviews the application and supporting documents for accuracy." },
              { number: "08", icon: "🏆", title: "RCMC Certificate Issuance", desc: "Receive your official Registration-Cum-Membership Certificate online." }
            ].map((step, index) => (
              <div key={index} className="sm:col-span-2 lg:col-span-2 flex flex-col justify-between p-3 bg-white rounded-xl shadow-md text-center hover:shadow-lg transition-shadow border-t-4 border-blue-500">
                <div className="flex flex-col flex-grow justify-center">
                  <span className="text-xl font-extrabold text-blue-600 block leading-tight">{step.number}</span>
                  <span className="text-2xl mx-auto block leading-none">{step.icon}</span>
                  <h3 className="text-base font-semibold text-gray-900 leading-snug mt-0.5">{step.title}</h3>
                  <p className="text-gray-600 text-sm text-justify mt-1 leading-snug">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Documents Section */}
      <section id="documents" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Only Scanned Copies are required
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              Mandatory Documents for APEDA Registration
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: "📄", title: "APEDA Registration Form", desc: "Completed APEDA registration form (online)." },
              { icon: "🆔", title: "IEC Certificate", desc: "IEC (Import Export Code) certificate." },
              { icon: "🏢", title: "Business Registration Proof", desc: "Certificate of Incorporation, Partnership Deed, or other business registration documents." },
              { icon: "💳", title: "PAN Card", desc: "PAN card of the business/applicant." },
              { icon: "🏦", title: "Bank Certificate", desc: "Bank certificate as per prescribed format by APEDA, or recent statement/cancelled cheque." },
              { icon: "📋", title: "GST Certificate", desc: "GST registration certificate." },
              { icon: "🏠", title: "Business Address Proof", desc: "Proof of business address (utility bill, rent/lease agreement, etc.)." },
              { icon: "🍎", title: "FSSAI License", desc: "FSSAI license (for food product exporters)." },
              { icon: "👨‍💼", title: "Director/Partner Details", desc: "List of directors/partners with identity proofs and authorization letter (if submitted via consultant/agent)." }
            ].map((doc, index) => (
              <div key={index} className="p-6 border rounded-xl shadow-md flex items-start space-x-4 h-full">
                <span className="text-2xl flex-shrink-0 mt-1">{doc.icon}</span>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">{doc.title}</h3>
                  <p className="text-gray-600 text-sm mt-1 text-justify">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What You Get Section */}
      <section id="you-get" className="py-20 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
              Your Deliverables
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              What Akir Advisory Delivers
            </p>
          </div>

          {/* 5 equal boxes in a single row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {[
              { icon: "🏆", title: "APEDA RCMC Certificate", desc: "Official APEDA Registration-Cum-Membership Certificate (RCMC) for exporters." },
              { icon: "🔑", title: "Portal Access", desc: "Portal account login credentials and registration status tracking access." },
              { icon: "💡", title: "Export Advisory", desc: "Comprehensive advisory on export incentives, schemes, and compliance requirements." },
              { icon: "🔄", title: "Update Support", desc: "Support for updating details, amendments, or renewals as needed." },
              { icon: "📝", title: "Export Documentation", desc: "Ready-to-use documentation for export clearance, customs compliance support, export incentive claim assistance, international trade documentation guidance" }
            ].map((item, index) => (
              <div key={index} className="p-5 bg-white rounded-xl shadow-lg border-l-4 border-green-500 flex flex-col h-full">
                <span className="text-2xl mb-2 block">{item.icon}</span>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-snug">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs Section */}
      <section id="service-faqs" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                  <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
                      Common Questions
                  </h2>
                  <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                      APEDA Registration FAQs
                  </p>
              </div>
              
              <div className="space-y-4 max-w-4xl mx-auto">
                {[
                  { 
                    question: "Is APEDA Registration mandatory for all exporters?", 
                    answer: "Only exporters of APEDA scheduled products require RCMC from APEDA." 
                  },
                  { 
                    question: "What is the registration fee?", 
                    answer: "The APEDA registration fee is ₹5000 + applicable taxes, paid online." 
                  },
                  { 
                    question: "How long does registration take?", 
                    answer: "Usually 7–10 working days from the date of application and payment." 
                  },
                  { 
                    question: "Is APEDA registration one-time or renewable?", 
                    answer: "It is a one-time registration but requires periodic updates of details and activity status." 
                  },
                  { 
                    question: "Can I export multiple products with one registration?", 
                    answer: "Yes, APEDA RCMC is valid for all scheduled products listed under the Act." 
                  }
                ].map((faq, index) => (
                  <div key={index} className="border rounded-lg p-5 shadow-sm">
                    <h4 className="font-semibold text-lg text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
          </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-16 bg-blue-700/90">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-extrabold text-white">
                Ready for APEDA Registration?
            </h2>
            <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto">
                Let our team of advisors simplify your agricultural export documentation and certification process.
            </p>
            <a href="#contact-section" className="mt-8 inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-full shadow-lg text-blue-700 bg-white hover:bg-gray-100 transition duration-150 ease-in-out transform hover:scale-105">
                <span className="mr-2">📞</span> Consult Our Expert Today
            </a>
        </div>
      </section>
    </main>
  );
};

export default APEDARegistration;